import React from "react";
import { Select } from "antd";
import { Label } from "../globals";
const { Option } = Select;

export default function SelectInput({
  value_return = "heavy",
  name,
  with_empty = false,
  label,
  required = false,
  placeholder = "",
  error = false,
  style = {},
  onChange,
  onSearch,
  value,
  disabled = false,
  options = [],
  extra_label,
  mode = "normal",
  filterByLabel = false,
  labelInValue = false,
}) {
  if (label === 'Parcel') {
    console.count('SelectInput');
  }

  const empty_arr = with_empty
    ? [
      {
        label: `No ${label?.toLowerCase() || "item"}`,
        value: "",
      },
    ]
    : [];

  return (
    <>
      {label && (
        <Label className="text-sm-label" required={required} error={error}>
          {extra_label ? (
            <div className="d-flex justify-content-between align-items-center">
              {label}
              {extra_label && (
                <div className="text-xs text-silver">{extra_label}</div>
              )}
            </div>
          ) : (
            label
          )}
        </Label>
      )}
      <Select
        showSearch
        mode={mode}
        className={error ? "error_border" : ""}
        style={{ width: "100%", ...style }}
        placeholder={placeholder || "Choose"}
        optionFilterProp={filterByLabel ? "label" : "children"}
        onChange={
          value_return == "heavy"
            ? onChange
            : (value) =>
              onChange({
                target: {
                  name,
                  value,
                },
              })
        }
        value={value}
        size="default"
        disabled={disabled}
        dropdownMatchSelectWidth={false}
      >
        {options
          ? [...empty_arr, ...options].map((item, index) => (
            <Option key={index} value={item.value} {...item}>
              {item.preview || item.label}
            </Option>
          ))
          : []}
      </Select>
      {error && <div className="text-danger">{error}</div>}
    </>
  );
}